<template>
  <Loading :loading="loading">
    <div class="cart container">
      <div v-if="cart && cart.groups" class="row">
        <div class="col-12 col-lg-8 cartContents my-3">
          <!-- All the items that cannot have their freight combined for the CT to home portion -->
          <CartGroup v-for="(group, key) in noncombinedFreightItems" :group="group" :groupKey="key" :key="key"/>


          <div v-if="combinedFreightItems && Object.keys(combinedFreightItems).length > 0" class="combinedItems">
            <!-- All the items that can be combined together -->
            <div v-if="cart.combined_freight_method == 'box'">
              <h4>&lt;25kg Courier Box to Home*</h4>
            </div>
            <div v-else-if="cart.combined_freight_method == 'bag'">
              <h4>Courier Bag to Home</h4>
            </div>
            <CartGroup v-for="(group, key) in combinedFreightItems" :group="group" :groupKey="key" :key="key" />
            <div class="frieghtCombined col-12 text-right">
              <span class="font-weight-bold">Combined freight to home cost: {{CurrencyFormatter(cart.combined_freight_total)}}</span>
            </div>
          </div>


          <div v-if="cart.expired_products && cart.expired_products.length > 0" class="cartExpired row my-3">
            <div class="col-12 row expired_product" v-for="expired in cart.expired_products" :key="expired.id">
              <div class="col-12 col-md-10">
                <router-link :to="{name: 'product', params:{product:expired.id}}" class="red">{{expired.title}}</router-link>
                has been removed from your cart as its price has expired.
              </div>
              <button
                @click="() => {$store.dispatch('cart/removeItem', {productId: expired.id})}"
                class="col-12 col-md-2 btn btn-sm btn-outline-warning remove-button"
              >
                Remove
              </button>
              <!-- send through product id to remove. Like remove button in rest of cart items-->
            </div>
          </div>
        </div>

        <!-- Delivery Details -->
        <div class="col-12 col-lg-4 cartSummary">
          {{cart.extra}}
          <div 
            class="my-3" 
            v-if="cart.address_valid"
          >
            Shipping to default address
            <MoreInfoPopover 
              class="address-popover"  
              width="auto" 
              v-if="delivery_details"
            >
              <p>{{delivery_details.delivery_name}}</p>
              <p>{{delivery_details.given_name}} {{delivery_details.family_name}}</p>
              <p>{{delivery_details.delivery_street_address}}</p>
              <p>{{delivery_details.delivery_suburb}}</p>
              <p>{{delivery_details.delivery_city}}, {{delivery_details.delivery_postcode}}</p>
            </MoreInfoPopover><br>
            <router-link :to="{name:'account'}">Change Address</router-link>
          </div>
          <!-- No delivery address prompt -->
          <div v-else class="my-3">
            <img 
              src="@/assets/img/important.jpg" 
              width="25px" 
              alt="Important Message Icon"
            > 
            <strong>
              You must set your address before we can calculate freight accurately and you can purchase.
              <router-link :to="{name:'account'}">Set Address</router-link>
            </strong>
          </div>

          <table class="cartTable">
            <tr>
            <!-- Cart Subtotal -->
              <td class="font-weight-bold col-6">Subtotal:</td>
              <td class="text-right col-6">{{CurrencyFormatter(cart.items_total)}}</td>
            </tr>
            <tr>
              <td class="font-weight-bold col-6">Freight:</td>
              <td class="text-right col-6">
                <div v-if="cart.freight_total == 0" class="includedFreight">Included in Subtotal</div>
                <span v-else>{{CurrencyFormatter(cart.freight_total)}}</span>
              </td>
            </tr>
            <tr>
            <!-- Cart Total -->
              <td class="font-weight-bold col-6">Total:</td>
              <td class="font-weight-bold text-right col-6">{{CurrencyFormatter(cart.total)}}</td>
            </tr>
            <tr>
              <td class="col-6">Savings off RRP:</td>
              <td class="col-6 text-right">{{CurrencyFormatter(cart.retail_total - cart.items_total)}}</td>
            </tr>
          </table>

          <!-- Cart Checkout Button -->
          <div class="text-center my-2">

            <!-- TODO: Re-enable the ZipPay button when that is requested. -->
            <!-- <span v-if="memberLevel == 'silver' && cart.total >= 200 && cart.total <= 1000">
              <button class="btn btn-primary col-5 zipPayButton" :disabled="!validCart">
                <img src="@/assets/img/zipLogo.png" alt="Zip Pay Logo"/>
                <span>Checkout with ZipPay</span>
              </button>
              <button
                @click="doCheckout"
                class="btn btn-primary col-5 pl-0 pr-0 offset-1"
                :disabled="!validCart"
              >
                Pay Now
              </button>
            </span> 
            <span v-else> -->
            <span>
              <button
                @click="doCheckout"
                class="btn btn-primary mx-auto btn-block"
                :disabled="!validCart"
              >
                Pay Now
              </button>
            </span>
          </div>
          <span class="error">{{message}}</span>
          
          <!-- Freight information -->
          <div v-if="cart.free_freight_threshold" class="cartMessage">Get Free freight on orders of {{CurrencyFormatter(cart.free_freight_threshold)}} or more</div>

          <!-- Information about boxes for frieght -->
          <div 
            v-if="cart.combined_freight_method == 'box'" 
            style="font-size:10pt;"
            class="cartMessage"
          >
            *Additional freight charges may apply if your order exceeds 25kgs or standard box dimensions.
          </div>

          <!-- Earnable points section -->
          <div
            v-if="cart.points_total && cart.points_total > 0"
            class="cartPoints cartMessage"
          >
            You'll earn {{cart.points_total}} {{cart.points_total == 1 ? 'point' : 'points'}} on this purchase.
          </div>
          <!--<div
            class="savings"
          >
            You're saving {{CurrencyFormatter(cart.retail_total - cart.items_total)}} off RRP
          </div>-->
          <div 
            v-if="cart.gold_total && memberLevel == 'silver'" 
            class="upgradeHint cartMessage"
          >
            <!-- Only show for silver -->
            You could save an extra {{CurrencyFormatter(cart.items_total - cart.gold_total)}} (excluding wholesale discounted freight charges) by upgrading to Gold before you make this purchase.
          </div>
        </div>
      </div>
      <div
        v-else 
        id="cart" 
        class="cart-empty my-5"
      >
        <div class="emptyMessage text-center">
          <!-- TODO CMS wording for empty cart -->
          <p>You haven't got any items in your cart yet.</p>
          <p>Head over to the shop to add some.</p>
          <router-link 
            class="btn btn-primary"
            :to="{name:'shop'}"
          >
            Shop Now
          </router-link>
        </div>
      </div>

      <UpgradeToGold 
        v-if="($store.state.auth.memberLevel == 'silver' || (memberLevel == 'gold' && !canTransact)) && cart" 
        :goldItemsTotal="cart.gold_total" 
        :memberItemsTotal="cart.items_total"
      />
    </div>
    <vue-headful title="Cart | Cherrytree"/>
  </Loading>
</template>

<script>
import { mapState } from "vuex";
import CartGroup from "./CartGroup";
import Loading from "@/components/loading/Loading";
import UpgradeToGold from "./UpgradeToGoldPrompt";

import { fetchCheckout } from "@/network/cartRequests";
import { fetchUserDetails } from "@/network/userRequests"

import { CurrencyFormatter, filterObject } from "@/utils";
import { makeProductObject } from "@/gaUtils";

import MoreInfoPopover from "@/components/MoreInfoPopover"

export default {
  name: "Cart",
  components: {
    CartGroup,
    Loading,
    UpgradeToGold,
    MoreInfoPopover
  },
  data() {
    return {
      loading: false,
      delivery_details: null,
      message: null
    };
  },
  created() {
    this.getData();
  },
  methods: {
    CurrencyFormatter,
    getData() {
      this.loading = true;
      this.$store.dispatch("cart/getCart").then(() => {
        this.loading = false
        this.gaCheckout(1)
      });
      fetchUserDetails(userDetails => {
        this.delivery_details = {
          "delivery_name": userDetails.member_details.given_name + ' ' + userDetails.member_details.family_name,
          "delivery_city": userDetails.member_details.delivery_city,
          "delivery_suburb": userDetails.member_details.delivery_suburb,
          "delivery_street_address": userDetails.member_details.delivery_street_address,
          "delivery_postcode": userDetails.member_details.delivery_postcode
        }
      })
    },
    doCheckout() {
      if(this.validCart) {
        fetchCheckout().then(response => {
          if(response.success == true){
            let paymentUrl = response.url;
            //pass in props so user cant go to page with it set in url
            this.gaCheckout(2)
            this.$router.push({name: 'payment', params:{paymentUrl: paymentUrl}})
          }else{
            if(response.message){
            //   console.log(response)
              this.message = response.message;
              if (response.message == "Delivery not specified") {
                this.message = "You need to select delivery options for all of your products."
              }
            }
          }
        });
      } else {
        this.message = "You need to pay your Gold Membership Fee";
      }
    },
    gaCheckout(step) {
      this.$gtm.trackEvent({
        event: "checkout",
        ecommerce: {
          checout: {
            actionField: {step},
            products: this.cartProducts
          }
        }
      })
    },
  },
  computed: {
    ...mapState({
      cart: state => state.cart.cart,
      memberLevel: state => state.auth.memberLevel,
      canTransact: state => state.member.canTransact,
    }),
    combinedFreightItems(){
      if(this.cart && this.cart.groups) {
        return filterObject(this.cart.groups, item => item.freight.combinable);
      }
      return null
    },
    noncombinedFreightItems(){
      if(this.cart && this.cart.groups) {
        return filterObject(this.cart.groups, item => !item.freight.combinable);
      }
      return null
    },
    validCart() {
      return this.cart.cart_valid && this.canTransact;  // If the cart is valid AND the user is allowed to transact.
    },
    cartProducts() {
      return Object.values(this.cart.groups)
              .map(group => Object.values(group.items))
              .flat()
              .map(item => makeProductObject(item.product, item.settings.quantity))
    },
  }
};
</script>

<style lang="scss" scoped>

.frieghtCombined{
  padding-top: 20px;
}

.combinedItems{
  padding:15px 5px;
  background:#eee;
}

.address-popover>div{
  width: auto !important;
}

.cartContents{
  padding: 0;
}

.expired_product{
  margin-bottom: 10px;
}

.includedFreight {
  min-width: 170px;
}

.cartMessage {
  margin: 5px 0;
}

.cartTable {
  .col-6 {
    padding-left: 0;
    padding-right: 0;
  }
}

.zipPayButton {
  background-color: #dcdcdc;
  border: none;
  color: #000;
  font-weight: normal;
  font-size: 0.6rem;
  padding: 2px 0;
  img {
    height: 20px;
    position: relative;
    display: block;
    margin: 0 auto;
  }
  &:hover {
    background-color: #bbb;
  }
  &:focus, &:active {
    background-color: #bbb !important;
    color: #000 !important;
  }
}

@include media-breakpoint-down(sm){
  .expired_product button{
    margin-left: 15px;
  }
}

.error {
  font-weight: bold;
  color: $CTred;
}

</style>
